import { ExportedTaskDto } from "./ExportedTaskDto";
import { ExportedTaskModel } from "./ExportedTaskModel";

export const transformExportedTaskDtoToModel = (
  dto: ExportedTaskDto
): ExportedTaskModel => dto;
